var operators;

operators = require('./binary-operators');

module.exports = operators({
  gt: function(a, b) {
    return a > b;
  },
  gte: function(a, b) {
    return a >= b;
  },
  lt: function(a, b) {
    return a < b;
  },
  lte: function(a, b) {
    return a <= b;
  },
  eq: function(a, b) {
    return a === b;
  },
  neq: function(a, b) {
    return a !== b;
  }
});
